import { ConfirmableFieldAlias } from "@/models/field-confirmation-interface";
import { InputByTypeProperties } from "@/models/form-builder-interface";

export interface TransferRule {
  accountId: number;
  mode: 'allow' | 'deny';
  relatedAccounts: string;
}

export interface AccountToAccountProps {
  id?: string;
  accountId?: number;
  walletId: number;
  inputProperties?: InputByTypeProperties;
  confirmBy?: ConfirmableFieldAlias;
  transferRules?: TransferRule[];
}

export const defaults = {};
